import { AppRouteRecordRaw } from '../types';

const ROUTERS: AppRouteRecordRaw = {
  path: '/contact-us',
  name: 'Contact',
  component: () => import('@/views/contact-us/index.vue'),
  meta: {
    locale: 'menu.contact',
    requiresAuth: false,
    icon: 'icon-phone',
    order: 100,
    hideInMenu: true,
  },
  children: [],
};

export default ROUTERS;
